
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { user, token } = useContext(AuthContext);
  const location = useLocation();

  // Require BOTH user and token
  if (user && token) return children;

  return <Navigate to="/login" state={{ from: location }} replace />;
}
